import { API } from '@/core/http/api'
import { MediaAPI } from '@/core/http/media-api'
import { parseMessageFromAPI } from '../../messages.api'

export async function getDraftMessage (id) {
  const res = await API.get(`messages/standalone/drafts/${id}`)
  return res.data
}

export async function getLastDrafts (page) {
  const res = await API.get(`messages/standalone/drafts?page=${page}`)
  return res.data
}

export async function createDraftMessage (type = 'standalone', parentMessageId, draftData) {
  const res = await API.post('messages/standalone/drafts', {
    type,
    parentMessageId,
    draftData
  })
  return res.data
}

export async function updateDraftMessage (id, data) {
  const res = await API.put(`messages/standalone/drafts/${id}`, data)
  return res.data
}

export async function uploadStandaloneMessageAttachment (id, data, config = {}) {
  const res = await API.post(`messages/standalone/drafts/${id}/attachment-upload`, data, config)
  return res.data
}

export async function uploadEmbeddedImage (data) {
  // Pending to add id to link to actual draft
  const res = await MediaAPI.post('embedded/upload', data)
  return res.data
}

export async function deleteStandaloneMessageAttachment (id, attachmentId) {
  const res = await API.delete(`messages/standalone/drafts/${id}/attachment/${attachmentId}`)
  return res.data
}

export async function getDraftMessages (page) {
  const res = await API.get(`messages/standalone/drafts?page=${page}`)
  return res.data
}

export async function sendStandaloneMessage (id) {
  const res = await API.post(`messages/standalone/drafts/${id}`)
  return parseMessageFromAPI(res.data.message)
}

export async function deleteMessageDraft (id) {
  const res = await API.delete(`messages/standalone/drafts/${id}`)
  return res.data
}

export async function getParticipantsInBox (boxId) {
  const res = await API.get(`boxes/box/${boxId}/participants`)
  return res.data
}
